<template>
  <div>
    <b-form
      @submit.prevent="filter"
      class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
    >
      <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
        <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
        <v-select
          :options="types"
          v-model="type"
          label="label"
          :reduce="(option) => option.value"
          :searchable="false"
          placeholder="Display on the page"
          class="w-100"
        ></v-select>
      </div>

      <div class="col-sm-6 col-12 d-flex align-items-center p-50">
        <b-form-input
          placeholder="search"
          v-model.trim="search"
          :disabled="!type"
        />
      </div>
      <div class="col-sm-3 col-12 p-50">
        <b-button
          class="w-100"
          type="submit"
          :disabled="
            !(type == 'active') && !(type == 'connectivity') && !search
          "
        >
          <span class="text-muted h5"> Filtering</span>
        </b-button>
      </div>
    </b-form>
    <b-row class="flex-row-reverse">
      <b-col lg="4" sm="6" cols="12" class="d-flex py-1">
        <b-card
          class="w-100 d-flex align-items-center cursor-pointer"
          body-class="d-flex flex-column justify-content-center align-items-center text-primary h3"
          @click="$router.push({ name: 'accounts-create' })"
        >
          <div class="text-center pb-1">
            <feather-icon
              style="padding: 5px"
              class="text-secondary rounded-circle bg-muted"
              icon="PlusIcon"
              size="30"
            />
          </div>
          <span class="text-muted">Add new account</span>
        </b-card>
      </b-col>
      <template v-if="loading">
        <b-col
          lg="4"
          sm="6"
          cols="12"
          v-for="(account, index) in 2"
          :key="index"
          class="d-flex py-1"
        >
          <b-card
            class="w-100"
            body-class="d-flex flex-column justify-content-between"
          >
            <b-skeleton width="90%" height="25px"></b-skeleton>
            <b-skeleton width="70%" height="25px"></b-skeleton>
            <b-skeleton width="60%" height="25px"></b-skeleton>
            <b-skeleton width="40%" height="25px"></b-skeleton>
          </b-card>
        </b-col>
      </template>
      <template v-else>
        <b-col
          lg="4"
          sm="6"
          cols="12"
          v-for="(account, index) in accounts"
          :key="index"
          class="d-flex py-1"
        >
          <account-card
            :account="account"
            @updateAccounts="getAccounts"
            @allExtra="allExtra"
            @openOrder="openOrder"
            @openHistory="openHistory"
          />
        </b-col>
      </template>
    </b-row>
    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
    <modal-open-history
      v-if="showModalOpenHistory"
      :showModal="showModalOpenHistory"
      :id="userId"
      @close="showModalOpenHistory = false"
    />
    <modal-open-orders
      v-if="showModalOpenOrder"
      :showModal="showModalOpenOrder"
      :id="userId"
      @close="showModalOpenOrder = false"
    />
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AccountCard from "./AccountCard.vue";
import VSelect from "vue-select";
import modalOpenHistory from "./modalOpenHistory.vue";
import modalOpenOrders from "./modalOpenOrders.vue";
import qs from "qs";

export default {
  components: {
    modalOpenOrders,
    modalOpenHistory,
    userId: "",
    BRow,
    BCol,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    AccountCard,
    BSkeleton,
    VSelect,
  },
  data() {
    return {
      selectAll: false,
      url: "/panel/accounts",
      currentPage: 1,
      loading: false,
      showModalOpenHistory: false,
      showModalOpenOrder: false,
      modalTitle: "",
      pagination: {},
      interval: "",
      accounts: [],
      orderData: {},
      selectedPage: "",

      Now: "",
      types: [
        // { label: "user_id", value: "user_id" },
        { label: "User name", value: "username" },
        // { label: "broker_id", value: "broker_id" },
        // { label: "is_demo", value: "is_demo" },
        { label: "Id", value: "mt_id" },
        // { label: "Active", value: "active" },
        // { label: "Connectivity", value: "connectivity" },
        { label: "Broker name", value: "broker.name" },
        // { label: "email", value: "user.email" },
        // { label: "first_name", value: "user.first_name" },
        // { label: "last_name", value: "user.last_name" },
      ],
      type: "",
      search: "",
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/accounts") {
        this.$router.push({
          name: "accounts",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "accounts",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      async handler(val) {
        this.loading = true;
        await this.getAccounts();
        this.loading = false;
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "accounts",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.interval);
    next();
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "accounts",
        query: {},
      });
    }
  },
  methods: {
    openOrder(id) {
      this.userId = id;
      this.showModalOpenOrder = true;
    },
    openHistory(id) {
      this.userId = id;
      this.showModalOpenHistory = true;
    },

    filter() {
      if (this.type) {
        let filter = {};
        this.type == "active" || this.type == "connectivity"
          ? (filter[this.type] = 1)
          : (filter[this.type] = this.search);
        this.$router.push({
          name: "accounts",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/accounts") {
        this.$router.push({
          name: "accounts",
        });
      }
    },
    removeAccount(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/accounts/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                await this.getAccounts();
              } else {
                await this.$router.push({
                  name: "accounts",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    async allExtra(id) {
      if (id == this.accounts[this.accounts.length - 1].id) {
        try {
          const { data } = await this.$http.post(
            `panel/accounts/all-extra?_method=patch`
          );
          this.getAccounts();
        } catch (err) {}
        this.interval = setInterval(async () => {
          if (this.$route.name == "accounts") {
            try {
              const { data } = await this.$http.post(
                `panel/accounts/all-extra?_method=patch`
              );
              this.getAccounts();
            } catch (err) {}
          }
        }, 20000);
      }
    },
    async getAccounts() {
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.accounts = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
    },
  },
};
</script>
